import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import AvatarImg from "../../../Assets/images/icons/user.png";
import { notFound } from "../../../enums/mainEnums";
import ContactData from "./contact-data";
import Reviews from "./reviews";
import IPs from "./IPs";
import Orders from "./Orders";
import Transactions from "./Transactions"; // New component

const UserDetailsPage = ({ data }) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
      <>
        {
          <div className={`flex flex-col items-start`}>
            <div className="flex gap-8">
              <div className="image-container w-28 h-28 rounded-full overflow-hidden">
                <img
                    src={data?.photo !== notFound ? data?.photo : AvatarImg}
                    className="w-full h-full object-cover"
                    alt={data?.name}
                />
              </div>
              <div className="user-data">
                <div className="flex flex-col items-start">
                  <div className="user-name font-bold">{data?.name}</div>
                  <div className="user-email font-bold mb-4">{data?.email}</div>
                  <div className="user-details flex gap-10">
                    <div className="user-created-at flex flex-col items-start">
                      <div>Added on</div>
                      <div className="font-bold">{data?.created_at}</div>{" "}
                    </div>
                    <div className="user-created-at flex flex-col items-start">
                      <div>IP</div>
                      <div className="font-bold">{data?.ip}</div>
                    </div>
                    <div className="user-created-at flex flex-col items-start">
                      <div>Country</div>
                      <div className="font-bold">{data?.country}</div>
                    </div>
                    <div className="user-reviews flex flex-col items-start">
                      <div>Balance</div>
                      <div className="font-bold">
                        ${data?.balance}
                      </div>{" "}
                    </div>
                    <div className="user-reviews flex flex-col items-start">
                      <div>Orders</div>
                      <div className="font-bold">
                        {data?.requests?.length}
                      </div>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="description">
              {data?.sex !== notFound && <div>sex: {data?.sex}</div>}
              {data?.about !== notFound && <div>about: {data?.about}</div>}
              {data?.description !== notFound && (
                  <div>description: {data?.description}</div>
              )}
            </div>
            <Box
                sx={{
                  borderBottom: 1,
                  marginTop: "20px",
                  borderColor: "divider",
                  width: "100%",
                }}
            >
              <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
              >
                <Tab label="Reviews on panel" id="simple-tab-0" />
                <Tab label="Reviews on service" id="simple-tab-1" />
                <Tab label="Contact" id="simple-tab-2" />
                <Tab label="IPs" id="simple-tab-3" />
                <Tab label="Orders" id="simple-tab-4" />
                <Tab label="Transactions" id="simple-tab-5" /> {/* New Tab */}
              </Tabs>
            </Box>
            <div
                role="tabpanel"
                hidden={value !== 0}
                id={`simple-tabpanel-${0}`}
                aria-labelledby={`simple-tab-${0}`}
                className="w-full"
            >
              {value === 0 && <Reviews data={data?.reviews_panel} type="panel" />}
            </div>
            <div
                role="tabpanel"
                hidden={value !== 1}
                id={`simple-tabpanel-${1}`}
                aria-labelledby={`simple-tab-${1}`}
                className="w-full"
            >
              {value === 1 && (
                  <Reviews data={data?.reviews_service} type="service" />
              )}
            </div>
            <div
                role="tabpanel"
                hidden={value !== 2}
                id={`simple-tabpanel-${2}`}
                aria-labelledby={`simple-tab-${2}`}
                className="w-full"
            >
              {value === 2 && <ContactData data={data} />}
            </div>
            <div
                role="tabpanel"
                hidden={value !== 3}
                id={`simple-tabpanel-${3}`}
                aria-labelledby={`simple-tab-${3}`}
                className="w-full"
            >
              {value === 3 && <IPs data={data} />}
            </div>
            <div
                role="tabpanel"
                hidden={value !== 4}
                id={`simple-tabpanel-${4}`}
                aria-labelledby={`simple-tab-${4}`}
                className="w-full"
            >
              {value === 4 && <Orders data={data?.requests} />}
            </div>
            <div
                role="tabpanel"
                hidden={value !== 5}
                id={`simple-tabpanel-${5}`}
                aria-labelledby={`simple-tab-${5}`}
                className="w-full"
            >
              {value === 5 && <Transactions data={data?.transactions} />}
            </div>
          </div>
        }
      </>
  );
};

export default UserDetailsPage;